var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1658 1.84167C12.8241 1.5 12.2324 1.73334 12.2324 2.20834V5.11667C12.2324 6.33334 13.2658 7.34167 14.5241 7.34167C15.3158 7.35 16.4158 7.35 17.3574 7.35C17.8324 7.35 18.0824 6.79167 17.7491 6.45834C16.5491 5.25 14.3991 3.075 13.1658 1.84167Z",
    fill: "#263BD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.084 8.49166H14.6757C12.7007 8.49166 11.0923 6.88332 11.0923 4.90832V2.49999C11.0923 2.04166 10.7173 1.66666 10.259 1.66666H6.72565C4.15898 1.66666 2.08398 3.33332 2.08398 6.30832V13.6917C2.08398 16.6667 4.15898 18.3333 6.72565 18.3333H13.2757C15.8423 18.3333 17.9173 16.6667 17.9173 13.6917V9.32499C17.9173 8.86666 17.5423 8.49166 17.084 8.49166ZM9.58398 14.7917H6.25065C5.90898 14.7917 5.62565 14.5083 5.62565 14.1667C5.62565 13.825 5.90898 13.5417 6.25065 13.5417H9.58398C9.92565 13.5417 10.209 13.825 10.209 14.1667C10.209 14.5083 9.92565 14.7917 9.58398 14.7917ZM11.2507 11.4583H6.25065C5.90898 11.4583 5.62565 11.175 5.62565 10.8333C5.62565 10.4917 5.90898 10.2083 6.25065 10.2083H11.2507C11.5923 10.2083 11.8757 10.4917 11.8757 10.8333C11.8757 11.175 11.5923 11.4583 11.2507 11.4583Z",
    fill: "#263BD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportColor);
export default __webpack_public_path__ + "static/media/ReportColor.7b0420e6716786c667b97800aa80e0d7.svg";
export { ForwardRef as ReactComponent };